/**
 * Zoho Flow integration utilities
 */

export function getZohoWebhookUrl(): string | undefined {
  // In a Vite app, use import.meta.env for environment variables
  return import.meta.env.VITE_ZOHO_FLOW_WEBHOOK_URL;
}

export async function postToZoho(payload: unknown): Promise<Response | undefined> {
  const webhookUrl = getZohoWebhookUrl();

  if (!webhookUrl) {
    console.warn('[ZOHO] Webhook URL not configured - skipping Zoho submission');
    return undefined;
  }

  try {
    console.log('[ZOHO] Submitting to Zoho Flow:', { url: webhookUrl, payload });

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error('[ZOHO] Webhook submission failed:', response.status, response.statusText);
    } else {
      console.log('[ZOHO] Webhook submission successful');
    }

    return response;
  } catch (error) {
    console.error('[ZOHO] Webhook submission error:', error);
    return undefined;
  }
}
